import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const steps = [['Listen', 'We start with your site, your life outside, and what you want the water to change.'], ['Shape', 'Together, we turn an early vision into a clear direction for the pool and landscape.'], ['Build', 'Your project moves forward with craft, communication, and attention to the details that matter.']];
export function Process() {
  return <section id="approach" className="bg-[#d8e7e1] py-20 sm:py-28" data-id="element-65">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-24" data-id="element-66">
        <div data-id="element-67">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#356d70]" data-id="element-68">
            A different way to build
          </p>
          <h2 className="mt-6 max-w-md text-4xl font-medium leading-tight tracking-[-0.045em] text-[#173d36] sm:text-5xl" data-id="element-69">
            Good pool design begins well before the digging.
          </h2>
          <p className="mt-6 max-w-md leading-7 text-[#49645b]" data-id="element-70">
            Our process keeps the practical and the personal in the same
            conversation—from water systems to the way the afternoon light falls
            on the patio.
          </p>
          <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#173d36] px-4 py-2 text-sm text-white" data-id="element-71">
            <CheckCircle2 size={16} className="text-[#8de0e5]" aria-hidden="true" data-id="element-72" />{' '}
            Built around your home
          </div>
        </div>
        <ol id="process" className="border-t border-[#9fbab0]" data-id="element-73">
          {steps.map(([title, copy], index) => <li key={title} className="grid grid-cols-[3rem_1fr] gap-4 border-b border-[#9fbab0] py-7 sm:grid-cols-[5rem_1fr]" data-id="element-74">
              <span className="font-mono text-sm text-[#356d70]" data-id="element-75">
                0{index + 1}
              </span>
              <div data-id="element-76">
                <h3 className="text-xl font-medium text-[#173d36]" data-id="element-77">{title}</h3>
                <p className="mt-2 max-w-md leading-7 text-[#49645b]" data-id="element-78">{copy}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}